import React from 'react';
import { PvSelect } from './PvSelect';

// We need a wrapper component to use react-select with redux-form
// the prop names are in conflict and will map wrong otherwise
export const ReactSelectWrapper = ({input, isLoading, options, placeholder, styles}) => (
  <PvSelect
    isLoading={isLoading}
    onBlur={() => input.onBlur(input.value)}
    onChange={input.onChange}
    options={options}
    placeholder={placeholder}
    styles={styles}
    value={input.value}
  />
);



// WEBPACK FOOTER //
// ./src/components/form/ReactSelectWrapper.jsx